import { Stack } from '@mui/material';
import * as React from 'react';
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';

import { FormErrorMessage } from '@/shared/components/ui/form/components/form-error-message/form-error-message';
import { FormLabel } from '@/shared/components/ui/form/components/form-label/form-label';
import { DEFAULT_ERROR_KEY } from '@/shared/utils/validation';

import { OTPSlot } from './components/otp-slot/otp-slot';
import { CodeInput, VerificationCodeContainer } from './otp-form-input.styled';
import type {
  TOtpFormInputProps,
  TOtpFormInputSlotProps,
} from './otp-form-types';

export const OtpFormInput = <TFieldValues extends FieldValues>({
  name,
  label,
  length = 6,
  separator = <span> </span>,
}: TOtpFormInputProps) => {
  const { control } = useFormContext<TFieldValues>();
  const inputRefs = React.useRef<HTMLInputElement[]>(
    new Array(length).fill(null),
  );

  return (
    <Controller
      name={name as Path<TFieldValues>}
      control={control}
      render={({ field, fieldState }) => (
        <Stack gap="0.5rem">
          {label && <FormLabel label={label} />}
          <VerificationCodeContainer>
            {new Array(length).fill(null).map((_, index) => (
              <React.Fragment key={index}>
                <CodeInput
                  value={field.value?.[index] ?? ''}
                  slotProps={
                    {
                      input: {
                        inputComponent: OTPSlot as any,
                        inputProps: {
                          index,
                          length,
                          currentOtpValue: field.value ?? '', // Add this
                          onOtpChange: field.onChange,
                          inputRefs,
                          'aria-label': `Digit ${index + 1} of OTP`,
                        },
                      },
                    } as TOtpFormInputSlotProps
                  }
                />
                {index === length - 1 ? null : separator}
              </React.Fragment>
            ))}
          </VerificationCodeContainer>
          {fieldState.error?.message &&
            fieldState.error.message !== DEFAULT_ERROR_KEY && (
              <FormErrorMessage
                field={label}
                errorMessage={fieldState.error.message}
              />
            )}
        </Stack>
      )}
    />
  );
};
